import { Skeleton } from '../../../components/ui/Skeleton';

interface LoadingDetailsI {
  numRows: number;
}
export function LoadingDetails(props: LoadingDetailsI) {
  const { numRows } = props;

  const buildRows = new Array(numRows).fill('Details Loading...');

  return (
    <div className="flex flex-col gap-4 p-4">
      {buildRows.map((_, i) => (
        <Skeleton className="h-5 w-full" key={`loading_detail_${i}`} />
      ))}
    </div>
  );
}
